import { Button } from "@mui/material"
import TMM from "entity/Indicador/TMM"
import TMT from "entity/Indicador/TMT"
import TTC from "entity/Indicador/TTC"
import Colheita from "entity/TipoIndicador/Colheita"

export const DebugConsole = ({ values }) => {
  const currentURL = window.location.href
  const inDebug = currentURL.includes("localhost") && !window.cordova
  if (!inDebug) {
    return ""
  }

  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        onClick={async () => console.log('valores filtro', values)}
      >
        Console Filtro Dev
      </Button>
    </div>
  )
}

export const DebugSetVisita = ({ change, filters }) => {
  const currentURL = window.location.href
  const inDebug = currentURL.includes("localhost") && !window.cordova
  if (!inDebug) {
    return ""
  }

  return (
    <div>
      <Button
        variant='contained'
        color='primary'
        onClick={async () => {
          console.log('filters dev')

          let obj = {
            dataInicio: "2024-05-16",
            dataFim: "2024-05-16",
            detalhaApontamentos: "Sim",
            tipo: "Perdas",
            agrupador: "",
            tiposIndicador: [
              new TTC(Colheita),
              new TMM(Colheita),
              new TMT(Colheita),
            ],
            tecnico: {
              nome: "Ivanildo Fernandes - OKDS",
              uid: "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
              email: "ivanildo.fernandes@okds.com",
              grupoPermissao: {
                userLastChange: "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
                nome: "Administrador",
                sequencialIndex: 1,
                uid: "r9jrEQXznNgjrZTGCfch",
                dataLastChange: {
                  seconds: 1584708135,
                  nanoseconds: 391000000
                }
              }
            },
            fazenda: {
              sequencialIndex: 4044,
              status: "ATIVO",
              dataLastChangeISO: "2023-07-20T14:01:05.234Z",
              cliente: {
                uid: "2D4sSMEB0LzMoTFt6tf3",
                salvoOffline: false,
                nome: "Teste de Indicadores",
                sequencialIndex: 225,
                status: "ATIVO",
                dataLastChange: {
                  seconds: 1657127935,
                  nanoseconds: 636000000
                },
                dataLastChangeStr: "06/07/2022 13:18",
                cidade: "Dourados",
                userLastChange: "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
                telefone: "6712345645",
                params: {
                  adh: {
                    manual: {
                      intervaloMin: "95",
                      metrosLinearesHectare: "30,56",
                      metrosLinearesAmostra: "10000",
                      meta: "90",
                      intervaloMax: "105"
                    }
                  },
                  vcc: {
                    manual: {
                      intervaloMax: "105",
                      intervaloMin: "95",
                      metrosLinearesAmostra: "50",
                      meta: "95",
                      metrosLinearesHectare: "6667"
                    }
                  }
                },
                estado: "MS"
              },
              cidadeFazenda: "Aa",
              enderecoFazenda: "Aaa",
              dataLastChangeServer: {
                seconds: 1689861663,
                nanoseconds: 984000000
              },
              talhoesFazenda: [
                {
                  area: "34.01",
                  nome: "15"
                },
                {
                  nome: "20",
                  area: "32.93"
                },
                {
                  area: "18.26",
                  nome: "19"
                }
              ],
              userLastChange: "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
              dataLastChangeStr: "20/07/2023 10:01",
              dataLastChange: {
                seconds: 1689861665,
                nanoseconds: 234000000
              },
              nomeFazenda: "Aa",
              estadoFazenda: "MS",
              uid: "jku19nIkiG1AbvL7DiSB",
              areaTotalFazenda: 85.2,
              codFazenda: "111"
            },
            cliente: [
              {
                status: "ATIVO",
                userLastChange: "ZWUmEfSidbU9sSQ6597iEuMzmSd2",
                dataLastChangeISO: "2024-04-24T15:22:19.541Z",
                sequencialIndex: 225,
                nome: "Teste de Indicadores",
                telefone: "",
                dataLastChangeServer: {
                  seconds: 1713972139,
                  nanoseconds: 686000000
                },
                params: {
                  pdt: {
                    items: [
                      {
                        classificacao: "Bom",
                        intervaloMin: "90",
                        sinalIntervaloMax: "<",
                        sinalIntervaloMin: ">=",
                        intervaloMax: "95"
                      },
                      {
                        sinalIntervaloMax: "<=",
                        intervaloMax: "100",
                        intervaloMin: "95",
                        classificacao: "Ótimo",
                        sinalIntervaloMin: ">="
                      },
                      {
                        intervaloMax: "91",
                        sinalIntervaloMin: ">=",
                        classificacao: "Ruim",
                        intervaloMin: "0",
                        sinalIntervaloMax: "<"
                      }
                    ],
                    manual: {
                      items: [
                        {
                          classificacao: "Bom",
                          intervaloMin: "94",
                          sinalIntervaloMin: ">=",
                          sinalIntervaloMax: "<=",
                          intervaloMax: "100"
                        }
                      ],
                      intervaloMin: "2",
                      meta: "94",
                      intervaloMax: "20"
                    },
                    mecanizado: {
                      intervaloMin: "1",
                      items: [
                        {
                          sinalIntervaloMin: ">=",
                          intervaloMin: "91",
                          classificacao: "Okay",
                          sinalIntervaloMax: "<=",
                          intervaloMax: "100"
                        }
                      ],
                      intervaloMax: "17",
                      meta: "91"
                    }
                  },
                  arsub: {
                    mecanizado: {
                      intervaloMax: "5",
                      meta: "90",
                      intervaloMin: "2"
                    },
                    manual: {
                      intervaloMax: "5",
                      meta: "90",
                      intervaloMin: "2"
                    }
                  },
                  pragasolo: {
                    manual: {
                      meta: "3",
                    }
                  },
                  ah: {
                    mecanizado: {
                      constante: "120000",
                      meta: "100",
                      intervaloMin: "0.5",
                      intervaloMax: "0.6",
                    }
                  },
                  lbm: {
                    manual: {
                      manual: {
                        metaBrocasInternas: "1"
                      },
                      meta: "2",
                      metaBrocasInternas: "1"
                    }
                  },
                  uql: {
                    manual: {
                      intervaloMax: "5",
                      intervaloMin: "2",
                      meta: "90"
                    },
                    mecanizado: {
                      intervaloMax: "5",
                      meta: "90",
                      intervaloMin: "2"
                    }
                  },
                  adc: {
                    manual: {
                      meta: "92",
                      metrosLinearesHectare: "4",
                      intervaloMax: "14",
                      metrosLinearesAmostra: "8",
                      intervaloMin: "2"
                    },
                    mecanizado: {
                      metrosLinearesHectare: "1",
                      metrosLinearesAmostra: "5",
                      meta: "95",
                      intervaloMin: "1",
                      intervaloMax: "15"
                    }
                  },
                  ps: {
                    manual: {
                      intervaloMax: "35",
                      meta: "90",
                      intervaloMin: "25"
                    },
                    items: [
                      {
                        classificacao: "Bom",
                        sinalIntervaloMax: "<",
                        sinalIntervaloMin: ">=",
                        intervaloMax: "98",
                        intervaloMin: "91"
                      },
                      {
                        sinalIntervaloMax: "<=",
                        classificacao: "Ótimo",
                        intervaloMax: "100",
                        sinalIntervaloMin: ">=",
                        intervaloMin: "98"
                      },
                      {
                        sinalIntervaloMin: ">=",
                        intervaloMin: "0",
                        intervaloMax: "90",
                        classificacao: "Ruim",
                        sinalIntervaloMax: "<"
                      }
                    ],
                    mecanizado: {
                      intervaloMax: "40",
                      meta: "80",
                      intervaloMin: "20"
                    }
                  },
                  perd: {
                    mecanizado: {
                      meta: "7"
                    }
                  },
                  ttp: {
                    manual: {
                      intervaloMin: "35",
                      items: [
                        {
                          intervaloMin: "35",
                          sinalIntervaloMax: "<=",
                          intervaloMax2: "45",
                          intervaloMin2: "35",
                          classificacao: "Bom",
                          sinalIntervaloMax2: "<=",
                          sinalIntervaloMin2: ">=",
                          sinalIntervaloMin: ">=",
                          intervaloMax: "35",
                          operador: "OR"
                        },
                        {
                          operador: "OR",
                          classificacao: "Ruim",
                          sinalIntervaloMax: ">=",
                          intervaloMax2: "100",
                          sinalIntervaloMin2: ">",
                          sinalIntervaloMin: "<",
                          intervaloMin2: "45",
                          sinalIntervaloMax2: ">=",
                          intervaloMin: "35",
                          intervaloMax: "0"
                        }
                      ],
                      meta: "95",
                      intervaloMax: "45"
                    },
                    items: [
                      {
                        sinalIntervaloMax: "<",
                        intervaloMax2: "20",
                        sinalIntervaloMax2: "<",
                        intervaloMin2: "10",
                        intervaloMax: "10",
                        operador: "OR",
                        classificacao: "Ruim",
                        sinalIntervaloMin2: ">=",
                        sinalIntervaloMin: ">=",
                        intervaloMin: "0"
                      },
                      {
                        operador: "OR",
                        intervaloMin: "20",
                        sinalIntervaloMin: ">=",
                        intervaloMax2: "70",
                        intervaloMax: "30",
                        sinalIntervaloMax: "<",
                        intervaloMin2: "30",
                        sinalIntervaloMin2: ">=",
                        classificacao: "Bom ",
                        sinalIntervaloMax2: "<"
                      },
                      {
                        sinalIntervaloMax2: "<=",
                        intervaloMin: "70",
                        operador: "OR",
                        sinalIntervaloMax: "<",
                        sinalIntervaloMin: ">=",
                        classificacao: "Ótimo",
                        intervaloMin2: "80",
                        intervaloMax: "80",
                        sinalIntervaloMin2: ">=",
                        intervaloMax2: "100"
                      }
                    ],
                    mecanizado: {
                      intervaloMax: "40",
                      intervaloMin: "20",
                      items: [
                        {
                          sinalIntervaloMax: "<=",
                          intervaloMin: "0",
                          sinalIntervaloMin: ">",
                          sinalIntervaloMax2: "<=",
                          classificacao: "hg",
                          intervaloMax2: "48",
                          operador: "AND",
                          sinalIntervaloMin2: ">",
                          intervaloMin2: "8",
                          intervaloMax: "8"
                        }
                      ],
                      meta: "98"
                    }
                  },
                  bio: {
                    manual: {
                      metrosAvaliados: "10",
                      metroLinear: "1",
                      canasAvaliadas: "10"
                    }
                  },
                  avl: {
                    mecanizado: {
                      meta: "98",
                      metrosLinearesHectare: "10",
                      intervaloMax: "49",
                      intervaloMin: "0"
                    },
                    manual: {
                      metrosLinearesHectare: "10",
                      metrosLinearesAmostra: "1",
                      intervaloMin: "0",
                      meta: "100",
                      intervaloMax: "49"
                    }
                  },
                  adh: {
                    mecanizado: {
                      metrosLinearesAmostra: "98",
                      intervaloMin: "88",
                      metrosLinearesHectare: "800",
                      intervaloMax: "98",
                      meta: "98"
                    }
                  },
                  cm: {
                    mecanizado: {
                      metrosLineares: "100",
                      metrosAvaliados: "1"
                    },
                    manual: {
                      meta: "1000",
                      metrosLineares: "1000",
                      metrosAvaliados: "1"
                    }
                  },
                  tmm: {
                    mecanizado: {
                      meta: "02:00"
                    },
                    items: []
                  },
                  altc: {
                    manual: {
                      meta: "90",
                      intervaloMaxVerao: "10",
                      intervaloMaxInverno: "10",
                      intervaloMinVerao: "5",
                      intervaloMinInverno: "5"
                    },
                    mecanizado: {
                      intervaloMaxInverno: "0.2",
                      meta: "92",
                      intervaloMinInverno: "0.02",
                      intervaloMinVerao: "0.02",
                      intervaloMaxVerao: "0.2"
                    },
                    items: [
                      {
                        intervaloMin: "0",
                        sinalIntervaloMin: ">=",
                        sinalIntervaloMax: "<",
                        classificacao: "Ruim",
                        intervaloMax: "90"
                      },
                      {
                        classificacao: "Regular",
                        sinalIntervaloMin: ">=",
                        sinalIntervaloMax: "<",
                        intervaloMax: "95",
                        intervaloMin: "90"
                      },
                      {
                        classificacao: "Ótimo",
                        sinalIntervaloMax: "<=",
                        sinalIntervaloMin: ">=",
                        intervaloMax: "100",
                        intervaloMin: "95"
                      }
                    ]
                  },
                  afc: {
                    mecanizado: {
                      metrosLinearesHectare: "10",
                      intervaloMin: "2",
                      intervaloMax: "6",
                      meta: "90",
                      metrosLinearesAmostra: "1"
                    },
                    manual: {
                      intervaloMin: "2",
                      intervaloMax: "6",
                      metrosLinearesHectare: "10",
                      metrosLinearesAmostra: "1",
                      meta: "90"
                    }
                  },
                  ipsp: {
                    manual: {
                      meta: "90"
                    },
                    mecanizado: {
                      meta: "90"
                    }
                  },
                  falhas: {
                    manual: {
                      meta: "1",
                      metrosPorPonto: "1"
                    }
                  },
                  mudaMecanizada: {
                    manual: {
                      meta: "80",
                      tamToletesPicadosParam: "95",
                      entrenosRachados: "10",
                      gemasDanificadas: "10",
                      nosRachados: "10",
                      tamToletesPicados: "10",
                      gemasDanificadasParam: "85",
                      palmitoAgregadoParam: "97",
                      nosRachadosParam: "97",
                      obs: "",
                      palmitoAgregado: "10",
                      entrenosRachadosParam: "97"
                    },
                    mecanizado: {
                      palmitoAgregado: "9",
                      entrenosRachados: "9",
                      gemasDanificadas: "9",
                      tamToletesPicados: "9",
                      nosRachados: "9"
                    }
                  },
                  pcorte: {
                    manual: {
                      intervaloMin: "1",
                      intervaloMaxInverno: "4",
                      intervaloMinInverno: "2",
                      intervaloMinVerao: "1",
                      intervaloMaxVerao: "5",
                      intervaloMax: "3",
                      meta: "90"
                    },
                    items: [
                      {
                        classificacao: "Bom",
                        sinalIntervaloMax: "<=",
                        intervaloMin: "90",
                        intervaloMax: "100",
                        sinalIntervaloMin: ">="
                      },
                      {
                        intervaloMax: "90",
                        classificacao: "Ruim",
                        intervaloMin: "0",
                        sinalIntervaloMax: "<",
                        sinalIntervaloMin: ">="
                      }
                    ]
                  },
                  ba: {
                    mecanizado: {
                      indiceMariposas: "9",
                      meta: "29"
                    },
                    items: [
                      {
                        intervaloMin: "0",
                        intervaloMax: "30",
                        classificacao: "Bom",
                        sinalIntervaloMin: ">=",
                        sinalIntervaloMax: "<="
                      },
                      {
                        intervaloMax: "100",
                        sinalIntervaloMin: ">",
                        sinalIntervaloMax: "<=",
                        classificacao: "Ruim",
                        intervaloMin: "30"
                      }
                    ],
                    manual: {
                      intervaloMax: "",
                      indiceMariposas: "10",
                      indiceMariposa: "10",
                      meta: "30",
                      intervaloMin: ""
                    }
                  },
                  adf: {
                    manual: {
                      metrosLinearesAmostra: "53",
                      meta: "93",
                      metrosLinearesHectare: "6.3",
                      intervaloMax: "103",
                      intervaloMin: "93"
                    },
                    mecanizado: {
                      intervaloMin: "94",
                      metrosLinearesHectare: "6",
                      meta: "92",
                      metrosLinearesAmostra: "54",
                      intervaloMax: "104"
                    }
                  },
                  adn: {
                    manual: {
                      meta: "100",
                      metrosLinearesHectare: "10",
                      intervaloMin: "0",
                      intervaloMax: "49",
                      metrosLinearesAmostra: "1"
                    },
                    mecanizado: {
                      intervaloMin: "0",
                      intervaloMax: "49",
                      meta: "100",
                      metrosLinearesAmostra: "1",
                      metrosLinearesHectare: "10"
                    }
                  },
                  dp: {
                    manual: {
                      meta: "5",
                      intervaloMax: "15",
                      items: [
                        {
                          sinalIntervaloMin: ">=",
                          intervaloMin: "5",
                          classificacao: "Okay",
                          intervaloMax: "15",
                          sinalIntervaloMax: "<="
                        }
                      ],
                      intervaloMin: "5"
                    },
                    mecanizado: {
                      intervaloMin: "2",
                      items: [
                        {
                          sinalIntervaloMin: ">=",
                          intervaloMax: "12",
                          intervaloMin: "2",
                          sinalIntervaloMax: "<=",
                          classificacao: "Bom"
                        }
                      ],
                      meta: "2",
                      intervaloMax: "12"
                    }
                  },
                  as: {
                    mecanizado: {
                      meta: "3"
                    },
                    items: [
                      {
                        sinalIntervaloMin: ">=",
                        classificacao: "Ótimo",
                        intervaloMin: "0",
                        sinalIntervaloMax: "<=",
                        intervaloMax: "5"
                      },
                      {
                        sinalIntervaloMin: ">",
                        intervaloMax: "10",
                        sinalIntervaloMax: "<=",
                        classificacao: "Bom",
                        intervaloMin: "5"
                      },
                      {
                        sinalIntervaloMax: "<=",
                        intervaloMax: "100",
                        intervaloMin: "10",
                        sinalIntervaloMin: ">",
                        classificacao: "Horrível"
                      }
                    ]
                  },
                  ngv: {
                    manual: {
                      metroPontoAvaliado: "1",
                      intervaloMax: "18",
                      meta: "100",
                      items: [
                        {}
                      ],
                      intervaloMin: "12"
                    },
                    meta: "94",
                    metroPontoAvaliado: "4",
                    intervaloMax: "24",
                    items: [
                      {
                        sinalIntervaloMin: ">=",
                        classificacao: "Abaixo",
                        intervaloMin: "0",
                        intervaloMax: "12",
                        sinalIntervaloMax: "<"
                      },
                      {
                        sinalIntervaloMin: ">=",
                        intervaloMax: "20",
                        sinalIntervaloMax: "<=",
                        intervaloMin: "12",
                        classificacao: "Boa"
                      },
                      {
                        sinalIntervaloMin: ">",
                        intervaloMax: "26",
                        sinalIntervaloMax: "<",
                        intervaloMin: "20",
                        classificacao: "Acima"
                      }
                    ],
                    mecanizado: {
                      intervaloMin: "5",
                      meta: "80",
                      metroPontoAvaliado: "1",
                      intervaloMax: "10"
                    },
                    intervaloMin: "14"
                  },
                  tmt: {
                    mecanizado: {
                      meta: "01:40"
                    },
                    items: [
                      {
                        classificacao: "Ótimo",
                        intervaloMax: "01:40",
                        intervaloMin: "00:00",
                        sinalIntervaloMin: ">=",
                        sinalIntervaloMax: "<="
                      },
                      {
                        sinalIntervaloMax: "<=",
                        intervaloMin: "01:40",
                        classificacao: "Bom",
                        sinalIntervaloMin: ">",
                        intervaloMax: "01:50"
                      },
                      {
                        intervaloMax: "02:00",
                        intervaloMin: "01:50",
                        classificacao: "Regular",
                        sinalIntervaloMin: ">",
                        sinalIntervaloMax: "<="
                      },
                      {
                        sinalIntervaloMin: ">",
                        intervaloMin: "02:00",
                        classificacao: "Ruim"
                      }
                    ]
                  },
                  pc: {
                    mecanizado: {
                      intervaloMin: "1",
                      meta: "91",
                      intervaloMax: "6"
                    },
                    manual: {
                      meta: "90",
                      intervaloMin: "2",
                      intervaloMax: "7"
                    },
                    intervaloMax: "7",
                    intervaloMin: "2"
                  },
                  acs: {
                    mecanizado: {
                      meta: "97"
                    },
                    items: [
                      {
                        sinalIntervaloMax: ">=",
                        sinalIntervaloMin: "<=",
                        intervaloMin: "99",
                        classificacao: "Ótimo",
                        intervaloMax: "95"
                      },
                      {
                        sinalIntervaloMin: "<",
                        classificacao: "Bom",
                        intervaloMax: "90",
                        intervaloMin: "95",
                        sinalIntervaloMax: ">="
                      },
                      {
                        classificacao: "Ruim",
                        sinalIntervaloMax: ">=",
                        intervaloMin: "90",
                        intervaloMax: "0",
                        sinalIntervaloMin: "<"
                      }
                    ]
                  },
                  TAH: {
                    mecanizado: {
                      meta: "90"
                    },
                    manual: {
                      meta: "90"
                    }
                  },
                  ado: {
                    manual: {
                      meta: "90",
                      intervaloMax: "8",
                      intervaloMin: "2",
                      metrosLinearesHectare: "10",
                      metrosLinearesAmostra: "2"
                    },
                    mecanizado: {
                      meta: "93",
                      intervaloMin: "3",
                      intervaloMax: "5",
                      metrosLinearesHectare: "9",
                      metrosLinearesAmostra: "4"
                    }
                  },
                  perf: {
                    manual: {
                      metrosAvaliados: "1"
                    }
                  },
                  vcc: {
                    manual: {
                      meta: "95",
                      metrosLinearesHectare: "5",
                      intervaloMin: "95",
                      metrosLinearesAmostra: "50",
                      intervaloMax: "105"
                    },
                    mecanizado: {
                      intervaloMin: "94",
                      metrosLinearesAmostra: "40",
                      intervaloMax: "104",
                      metrosLinearesHectare: "4",
                      meta: "94"
                    }
                  },
                  ees: {
                    manual: {
                      intervaloMax: "1.55",
                      meta: "90",
                      intervaloMin: "1.45"
                    },
                    mecanizado: {
                      intervaloMin: "1.40",
                      intervaloMax: "1.50",
                      meta: "90"
                    },
                    items: [
                      {
                        intervaloMin: "99",
                        sinalIntervaloMax: "<=",
                        classificacao: "Ótimo",
                        intervaloMax: "100",
                        sinalIntervaloMin: ">="
                      },
                      {
                        sinalIntervaloMax: "<",
                        intervaloMin: "95",
                        intervaloMax: "98",
                        classificacao: "Bom",
                        sinalIntervaloMin: ">="
                      },
                      {
                        sinalIntervaloMin: ">=",
                        classificacao: "Regular",
                        intervaloMax: "95",
                        sinalIntervaloMax: "<",
                        intervaloMin: "90"
                      },
                      {
                        intervaloMax: "90",
                        sinalIntervaloMax: "<",
                        classificacao: "Ruim",
                        intervaloMin: "0",
                        sinalIntervaloMin: ">="
                      }
                    ]
                  },
                  ttc: {
                    mecanizado: {
                      meta: "01:00"
                    },
                    manual: {
                      meta: "01:00"
                    }
                  },
                  ibf: {
                    mecanizado: {
                      meta: "18"
                    }
                  },
                  piso: {
                    mecanizado: {
                      meta: "3"
                    }
                  },
                  lc: {
                    manual: {
                      intervaloMin: "0",
                      metroPontoAvaliado: "4",
                      metaMaxAdultas: "2",
                      meta: "2",
                      intervaloMax: "7"
                    },
                    items: [
                      {
                        sinalIntervaloMin: ">=",
                        intervaloMax: "100",
                        sinalIntervaloMax: "<=",
                        intervaloMin: "95",
                        classificacao: "Ótimo"
                      },
                      {
                        intervaloMin: "95",
                        classificacao: "Bom",
                        sinalIntervaloMax: ">=",
                        intervaloMax: "90",
                        sinalIntervaloMin: "<"
                      },
                      {
                        intervaloMax: "0",
                        classificacao: "Ruim",
                        intervaloMin: "90",
                        sinalIntervaloMin: "<",
                        sinalIntervaloMax: ">="
                      }
                    ]
                  }
                },
                tempAdd: null,
                salvoOffline: false,
                anexos: {
                  type: "application/pdf",
                  userUid: "lZLannLpO5N5dEPYQe0aKo5fCIj2",
                  downloadURL: "https://firebasestorage.googleapis.com/v0/b/tchqualidade.appspot.com/o/cliente%2Fanexos%2FmetodologiasAvaliacao%2FViEv1LYy65Nedh0vAYbb-dummy.pdf?alt=media&token=c5b2d305-0241-41b4-b9e6-a667539b1746",
                  dateUpdate: "2023-09-29T15:23:48.898Z",
                  realName: "dummy.pdf",
                  dateCreate: "2023-09-29T15:23:48.898Z",
                  storagePath: "cliente/anexos/metodologiasAvaliacao/ViEv1LYy65Nedh0vAYbb-dummy.pdf",
                  filename: "ViEv1LYy65Nedh0vAYbb-dummy.pdf",
                  size: 13264,
                  userName: "Carlos Antonio - OKDS"
                },
                cidade: "",
                estado: "",
                perfisAutorizado: {
                  Uy5WfGYlwAVUKLfA6gZAuEImPon1: true,
                  lZLannLpO5N5dEPYQe0aKo5fCIj2: true
                },
                dataLastChange: {
                  seconds: 1713972139,
                  nanoseconds: 541000000
                },
                uid: "2D4sSMEB0LzMoTFt6tf3",
                dataLastChangeStr: "24/04/2024 11:22",
                key: "2"
              }
            ]
          }

          change('cliente', obj.cliente)
          change('dataInicio', obj.dataInicio)
          change('dataFim', obj.dataFim)
          change('detalhaApontamentos', obj.detalhaApontamentos)
          change('tipo', obj.tipo)
          // change('tiposIndicador', obj.tiposIndicador)
          // change('agrupador', obj.agrupador)
          // change('tecnico', obj.tecnico)
          // change('fazenda', obj.fazenda)
        }}
      >
        Definir Filtros Rel. Dev
      </Button>
    </div>
  )
}